/*eslint-disable */
import addPaperPopup from '@/components/researchPapers/add-papers-popup/';
import { bus } from '@/main';
export default {
  name: 'favourite-papers-list',
  components: {
    'add-paper-popup' : addPaperPopup
  },
  props: [],
  data () {
    return {
      addPaperPopupState:false,
      paperPileDetails:{},
      paperPileResults:[],
      nextPageUrl:'',
      nextSteper:'',
      userLoading:false,
      pdf_is_fav:Boolean,
      pdfViewerPopup:false,
      pdfViewerUrl:'',
      pdfId:'',
      pdfViewerFileName:'',
      updatePaperPileDetailPopupState:false,
      search_term:'',
      normalPaperPileListState:true,
      searchPaperPileListState:false,
      searchPaperPileData:null,
      searchPaperPileList:[],
      paperMoverToFolder:false,
      paperMoverToFolderData:null,
      notesViewData:null,
      notesViewPopupState:false,
      paperUpdateInfo:null,
      paperSelected:'',
      trashPaperState:false,
      trashPaperId:'',
      sharedPaperState:false,
      sharedPaperInfo:null,
      sharedPaperResultData:null,
      sharedPaperResultList:[],
      selfUserInfo:null,
      citationPopupState:false,
      citationPaperId:''
    }
  },
  computed: {

  },
  mounted () {
    bus.$on('addPaperPopupStateBus', (data) => {
      this.addPaperPopupState = data;
    });
  },
  methods: {
    openPopupOfAddPapersMethod(){
      this.addPaperPopupState = true
      document.body.classList.add('body_right_scroll_remove')
    },

  }
}